<div
    class="btn-group"
    [ngClass]="{
        dropup: dropUp,
        'no-dropdown': hideDropdown,
        'form-input': isFormControl,
        disabled: disabled,
    }"
>
    @if (style === "none") {
        <div [class.form-input]="isFormControl" data-toggle="dropdown" (click)="toggle()">
            <ng-content select="div, span, a, p, strong, i, b, ul, li, kui-icon"></ng-content>
        </div>
    }
    @if (style !== "none") {
        <button
            kui-button
            class="dropdown-toggle d-flex align-items-center"
            data-toggle="dropdown"
            [class.form-control]="isFormControl"
            [color]="style"
            [size]="buttonSize"
            [outlined]="outlined"
            (click)="toggle()"
        >
            <ng-content></ng-content>
            <ng-content select="kui-dropdown-button"></ng-content>
            @if (!dropUp) {
                <kui-icon class="ml-2" name="caret-down"></kui-icon>
            }
            @if (dropUp) {
                <kui-icon class="ml-2" name="caret-up"></kui-icon>
            }
        </button>
    }
</div>
